declare global {
	interface Window {
		dataLayer: any[];
	}
}

export const trackEvent = (event: string, data: Record<string, unknown>) => {
	if (typeof window !== 'undefined') {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event,
			eventLabel: data.eventLabel ?? '',
			...data,
		});
	}
};
